import React from 'react';

export function SkipLink({ targetId = 'main', children, className = 'a11y-skip-link' }) {
  const onClick = (e) => {
    e.preventDefault();
    if (typeof document === 'undefined') return;
    const el = document.getElementById(targetId);
    if (!el) return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      try { el.focus(); } catch (e) {  }
    }
    if (typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ block: 'start' });
    }
  };
  return (
    <a href={'#' + targetId} onClick={onClick} className={className}>
      {children || 'Skip to main content'}
    </a>
  );
}

export default SkipLink;
